import { render, staticRenderFns } from "./myRadio.vue?vue&type=template&id=4fa02c71&scoped=true&"
import script from "./myRadio.vue?vue&type=script&lang=js&"
export * from "./myRadio.vue?vue&type=script&lang=js&"
import style0 from "./myRadio.vue?vue&type=style&index=0&id=4fa02c71&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fa02c71",
  null
  
)

component.options.__file = "myRadio.vue"
export default component.exports